module.exports = __webpack_public_path__ + "static/raphael_concept_bg3-4cfefd7983ed44ac8c8d7f28a026dbaf.webp";